import { authGet } from "@api/auth/auth";
import { DEPLOYMENT_URL } from "@constants";
import { DeploymentScansResponse } from "@types";

export const fetchDeploymentScans = (
  deploymentId: string,
  searchParams?: URLSearchParams
): Promise<DeploymentScansResponse> => {
  let queryString = searchParams ? `?${searchParams.toString()}` : "";
  return authGet<DeploymentScansResponse>(
    `${DEPLOYMENT_URL}/${deploymentId}/scans${queryString}`
  );
};
